import React, { useEffect, useState } from "react";
import Breadcrumbs from "../layout/breadcrumb";
import leftArrow from "../../assets/Images/left-arrow.png";
import rightArrow from "../../assets/Images/right-arrow.png";
import "../my-approval/approval.css";
import "./mytask.css";
import Close from "../../assets/Images/close.png";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Filter from "../../assets/Icons/filter.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Manpower from "../dpr/resources/manpower";
import Machinery from "../dpr/resources/machinery";
import Material from "../dpr/resources/material";
import ScopeChart from "../dpr/scopeChart/scopeChart";
import RiskResgisterList from "../risk-register/risk-list-dpr";
import IssueResgisterList from "../issue-register/issue-list-dpr";
import ManpowerList from "../dpr/resources/manpower-list";
import MachineryList from "../dpr/resources/machinery-list";
import IssueRegisterForm from "../issue-register/issue-register-form";
import RiskRegisterForm from "../risk-register/risk-register-form";
import { DPR_API } from "../../services/apiCalls/dprApiCalls";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ExcelExport from "../../compnenets/commons/xls";

export default function Mytasks() {
  const [openFilter, setOpenFilter] = useState(false);
  const [open, setOpen] = useState(false);
  const [openRisk, setOpenRisk] = useState(false);
  const [openIssu, setOpenIssu] = useState(false);
  const [subId, setSubId] = useState("");
  const [resourceTitle, setResourceTitle] = useState("Manpower");
  const [openModalRiskList, setOpenModalRiskList] = useState(false);
  const [openModalIssueList, setOpenModalIssueList] = useState(false);
  const [openResourcesList, setOpenResoucresList] = useState(false);
  const [dprFilter, setTaskFilter] = useState({
    DPRName: "",
    DPRType: "",
    StartDate: "",
    EndDate: "",
    DateRange: "",
  });
  const [projectId, setProject] = useState({});
  const [openScopeChart, setOpenScopeChart] = useState(false);
  const [planStart, setPlanStart] = useState("");
  const [planFinish, setPlanFinish] = useState("");
  const [dprName, setDprName] = useState("");
  const [balanceScope, setBalanceScope] = useState("");
  const handleChange = (event) => {
    const { name, value } = event.target;
    setTaskFilter((prev) => ({ ...prev, [name]: value }));
  };
  const closeM = (va) => {
    setOpen(va);
  };
  const onCloseModalRisk = () => {
    setOpenRisk(true);
  };
  const onCloseModalIssue = () => {
    setOpenRisk(true);
  };
  const openModalRisk = (id, project) => {
    setSubId(id);
    setOpenRisk(true);
    setProject(project);
  };
  const openModalIssue = (id, project) => {
    setSubId(id);
    setOpenIssu(true);
    setProject(project);
  };

  const onClickOpen = (w_id, project_id) => {
    setSubId(w_id);
    setOpen(true);
    setProject({ project_id: project_id });
  };
  const onCloseModal = () => setOpen(false);

  const [tasksList, setTasksList] = useState([]);
  const onCloseModalFilter = () => setOpenFilter(true);
  const getMyTasks = async () => {
    let user = JSON.parse(localStorage.getItem("state"));
    console.log(user);
    let Obj = {
      UserID: user.user?.user_id,
    };
    const apprl = await DPR_API?.getMytasks(Obj);
    if (apprl && apprl?.subtasks?.length) {
      setTasksList(apprl?.subtasks);
    } else {
      setTasksList([]);
    }
    setTaskFilter({
      DPRName: "",
      DPRType: "",
      StartDate: "",
      EndDate: "",
      DateRange: "",
    });
  };

  const onFilter = async () => {
    getMyTasks();
  };

  useEffect(() => {
    getMyTasks();
  }, []);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(tasksList.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = tasksList.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const handleInputChange = (index, field, value, weightage = "") => {
    setTasksList((prevDprDatas) => {
      const updatedDprData = prevDprDatas.map((subtask, idx) => {
        if (idx === index) {
          const parsedValue = value === "" ? 0 : parseFloat(value) || 0;
          const finalScope = subtask.FinalScope || 0;
          const PreviousProgress = subtask.PreviousProgress || 0;
          const currentRate =
            field === "CurrentRate" ? parsedValue : subtask.CurrentRate || 1;
          const balanceScope =
            field === "TodayProgress" || field === "FinalScope"
              ? finalScope -
                (PreviousProgress +
                  (field === "TodayProgress"
                    ? parsedValue
                    : subtask.TodayProgress || 0))
              : subtask.BalanceScope;

          const expectedFinish =
            currentRate > 0 && balanceScope >= 0
              ? parseFloat((balanceScope / currentRate).toFixed(2))
              : 0;

          return {
            ...subtask,
            [field]:
              field === "TodayProgress" ||
              field === "FinalScope" ||
              field === "CurrentRate"
                ? parsedValue
                : value,

            Cumulative:
              field === "TodayProgress"
                ? PreviousProgress + parsedValue
                : subtask.Cumulative,

            ProgressPercentage:
              field === "TodayProgress" || field === "FinalScope"
                ? finalScope !== 0
                  ? (
                      ((PreviousProgress +
                        (field === "TodayProgress"
                          ? parsedValue
                          : subtask.TodayProgress || 0)) /
                        finalScope) *
                      100
                    ).toFixed(2)
                  : 0
                : subtask.ProgressPercentage,

            WeightedProgress:
              field === "TodayProgress" || field === "Weightage"
                ? finalScope !== 0
                  ? (
                      ((PreviousProgress +
                        (field === "TodayProgress"
                          ? parsedValue
                          : subtask.TodayProgress || 0)) /
                        finalScope) *
                      (subtask.Weightage || weightage)
                    ).toFixed(2)
                  : 0
                : subtask.WeightedProgress,

            BalanceScope: balanceScope,

            Status:
              field === "TodayProgress" || field === "FinalScope"
                ? ((PreviousProgress +
                    (field === "TodayProgress"
                      ? parsedValue
                      : subtask.TodayProgress || 0)) /
                    finalScope) *
                    100 ===
                  100
                  ? "Completed"
                  : "In Progress"
                : subtask.Status,

            ExpectedFinish: expectedFinish,
          };
        }
        return subtask;
      });
      return updatedDprData;
    });
  };
  const handleSubmit = async () => {
    console.log(tasksList, "---------");
    if (tasksList.length > 0) {
      const response = await DPR_API.updateDprDaliy(tasksList);
      console.log(response);
    } else {
      toast.warning("No task found!", { autoClose: 2000 });
    }
  };
  const handleOnAuditClick = (dprid) => {
    console.log(dprid, "-----");
  };

  const handleScopeChartClick = (val) => {
    setSubId(val?.DPRID);
    setOpenScopeChart(true);
    setPlanStart(val?.PlannedStart);
    setPlanFinish(val?.PlannedFinish);
    setDprName(val.Subtask);
    setBalanceScope(val.BalanceScope);
    setProject({ project_id: val.ProjectID });
  };
  return (
    <React.Fragment>
      <div className="pb-0">
        <Breadcrumbs title="My Tasks" menu="" link="My Tasks" />
      </div>
      <div className="row" style={{ marginRight: 25 }}>
        <div className="d-flex justify-content-end">
          <div className="download-icon">
            <ExcelExport
              data={tasksList}
              fileName="My approval"
              sheet="My approval"
            />
          </div>
          <div className="filter-icon mx-2 my-auto">
            <img
              className=""
              onClick={() => {
                setOpenFilter(true);
              }}
              src={Filter}
              width={20}
            />
          </div>
          <div
            className="my-auto"
            onClick={() => {
              getMyTasks();
            }}
          >
            <span
              style={{
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 500,
                background: "#8add79f7",
                padding: 5,
                borderRadius: 12,
              }}
            >
              Clear filters
            </span>
          </div>
        </div>
      </div>
      <div className="table-container-dpr" id="table-mytask">
        <table className="custom-table-dpr">
          <thead className="table-header">
            <tr>
              {/* <th style={{ width: "70px" }}>Sr No</th> */}
              <th style={{ minWidth: "50px" }}>Project Id</th>
              <th>Project Name</th>
              <th>Client</th>
              <th>Location</th>
              <th>Work Package</th>
              <th>Task</th>
              <th>Weightage</th>
              <th>Initial Scope</th>
              <th>Final Scope</th>
              <th>UOM</th>
              <th>Prev. Progress</th>
              <th>Today's Progress</th>
              <th>Cumulative</th>
              <th>Progress %</th>
              <th>Weightage Progress</th>
              <th>Balance Scope</th>
              <th>Planned Start</th>
              <th>Planned Finish</th>
              <th>Scope Chart</th>
              <th>Current Rate</th>
              <th>Asking Rate</th>
              <th>Actual Start</th>
              <th>Actual Finish</th>
              <th>Expected Finish</th>
              <th>Status</th>

              <th>Risk</th>
              <th>Issue</th>
              <th>Resources</th>
              <th>Upload picture</th>
              <th>Audit log</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index}>
                {/* <td style={{ width: "70px" }} id="elps">
                  {index + 1}
                </td> */}
                <td
                  style={{ minWidth: "50px" }}
                  id="elps"
                  title={row.ProjectID}
                >
                  {row.ProjectID}
                </td>
                <td id="elps" title={row.ProjectName}>
                  {row.ProjectName}
                </td>
                <td id="elps" title={"client"}>
                  {"client"}
                </td>
                <td id="elps" title={"title"}>
                  {"location"}
                </td>
                <td id="elps" title={row.WorkPackage}>
                  {row.WorkPackage}
                </td>
                <td id="elps" title={row.Subtask}>
                  {row.Subtask}
                </td>
                <td id="elps" title={row.Weightage}>
                  {row.Weightage}
                </td>
                <td id="elps" title={row.InitialScope}>
                  {row.InitialScope}
                </td>
                <td id="elps" title={row.FinalScope}>
                  {row.FinalScope}
                </td>
                <td id="elps" title={row.UOM}>
                  {row.UOM}
                </td>
                <td id="elps" title={row.PreviousProgress}>
                  {row.PreviousProgress}
                </td>
                <td id="elps" title={row.TodayProgress}>
                  <input
                    type="number"
                    className="form-control shadow-none"
                    value={row.TodayProgress}
                    onInput={(e) =>
                      handleInputChange(
                        index,
                        "TodayProgress",
                        parseInt(e.target.value, 10),
                        row.Weightage
                      )
                    }
                  />
                  {/* {row.TodayProgress} */}
                </td>
                <td id="elps" title={row.Cumulative}>
                  {row.Cumulative}
                </td>
                <td id="elps" title={row.ProgressPercentage}>
                  {row.ProgressPercentage}
                </td>
                <td id="elps" title={row.WeightedProgress}>
                  {row.WeightedProgress}
                </td>
                <td id="elps" title={row.BalanceScope}>
                  {row.BalanceScope}
                </td>
                <td id="elps" title={row.PlannedStart}>
                  {row.PlannedStart}
                </td>

                <td id="elps" title={row.PlannedFinish}>
                  {row.PlannedFinish}
                </td>
                <td id="elps">
                  <button
                    style={{ width: 100, border: "0px solid" }}
                    onClick={() => handleScopeChartClick(row)}
                  >
                    Scope Chart
                  </button>
                </td>
                <td id="elps" title={row.CurrentRate}>
                  {row.CurrentRate}
                </td>
                <td id="elps" title={row.AskingRate}>
                  {row.AskingRate}
                </td>
                <td>
                  <input
                    value={row.ActualStart}
                    className="form-control shadow-none"
                    onChange={(e) => {
                      handleInputChange(index, "ActualStart", e.target.value);
                    }}
                    min={new Date().toISOString().split("T")[0]}
                    type="date"
                    style={{ width: "110px" }}
                  />
                </td>
                <td>
                  <input
                    className="form-control shadow-none"
                    value={row.ActualFinish}
                    type="date"
                    min={row.ActualStart}
                    onChange={(e) => {
                      handleInputChange(index, "ActualFinish", e.target.value);
                    }}
                    style={{ width: "110px" }}
                    disabled={row.ActualStart === null}
                  />
                </td>
                <td id="elps" title={row.ExpectedFinish}>
                  {row.ExpectedFinish}
                </td>
                <td id="elps" title={row.Status}>
                  {row.Status}
                </td>
                <td>
                  <div className="d-flex">
                    <button
                      className="btn btn-primary"
                      onClick={() =>
                        openModalRisk(row?.DPRID, {
                          project_id: row?.ProjectID,
                          Project_Name: row?.ProjectName,
                          Product_Category: row?.Product_Category,
                          Location: row?.Location,
                        })
                      }
                      // disabled={!row.DPRID}
                    >
                      Risk
                    </button>
                    <button
                      className="show-reaource"
                      onClick={() => {
                        setSubId(row?.DPRID);
                        setOpenModalRiskList(true);
                      }}
                      // disabled={!row.DPRID}
                    >
                      View
                    </button>
                  </div>
                </td>
                <td>
                  <div className="d-flex">
                    <button
                      className="btn btn-primary"
                      onClick={() =>
                        openModalIssue(row?.DPRID, {
                          project_id: row?.ProjectID,
                          Project_Name: row?.ProjectName,
                          Product_Category: row?.Product_Category,
                          Location: row?.Location,
                        })
                      }
                    >
                      Issue
                    </button>
                    <button
                      className="show-reaource"
                      onClick={() => {
                        setSubId(row?.DPRID);
                        setOpenModalIssueList(true);
                      }}
                      // disabled={!row.DPRID}
                    >
                      View
                    </button>
                  </div>
                </td>
                <td>
                  <div className="d-flex">
                    <button
                      className="btn btn-primary"
                      onClick={() => onClickOpen(row?.DPRID, row?.ProjectID)}
                      // disabled={!row.DPRID}
                    >
                      Open
                    </button>

                    <button
                      className="show-reaource"
                      onClick={() => {
                        setSubId(row?.DPRID);
                        setOpenResoucresList(true);
                      }}

                      // disabled={!row.DPRID}
                    >
                      View
                    </button>
                  </div>
                </td>
                <td id="elps" title={row.UploadPicture}>
                  {row.UploadPicture}
                </td>
                <td>
                  <div className="d-flex justify-content-center align-items-center">
                    <FontAwesomeIcon
                      icon={faInfoCircle}
                      style={{
                        height: "20px",
                        width: "20px",
                        color: "#0d6efd",
                        cursor: "pointer",
                      }}
                      onClick={(e) => handleOnAuditClick(row?.DPRID)}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        className="pagination"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 15px",
        }}
      >
        <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
          Showing{" "}
          {Math.min((currentPage - 1) * rowsPerPage + 1, tasksList.length)} to{" "}
          {Math.min(currentPage * rowsPerPage, tasksList.length)} of{" "}
          {tasksList.length} entries
        </div>
        <div
          className="pagination-buttons"
          style={{
            fontSize: "14px",
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            gap: "5px",
          }}
        >
          {/* Left Arrow */}
          <button
            onClick={() => handleClick(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={leftArrow} // Replace with your actual image path
              alt="Previous"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
            />
          </button>
          {/* Page Numbers */}
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => handleClick(i + 1)}
              style={{
                background: currentPage === i + 1 ? "#00B69B" : "transparent",
                color: currentPage === i + 1 ? "#fff" : "#000",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              {i + 1}
            </button>
          ))}
          {/* Right Arrow */}
          <button
            onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={rightArrow} // Replace with your actual image path
              alt="Next"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
            />
          </button>
        </div>
      </div>
      <div className="row mt-4">
        <div class="d-flex justify-content-end">
          <div style={{ margin: 10 }}>
            <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>
          </div>
          <div style={{ margin: 10 }}>
            <button className="btn btn-danger" onClick={() => {}}>
              Cancel
            </button>
          </div>
        </div>
      </div>

      <Modal open={openFilter} onClose={onCloseModalFilter} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">My Tasks Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpenFilter(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <label className="filter-label">Start date</label>
                  <input
                    value={dprFilter?.StartDate}
                    onChange={handleChange}
                    name="StartDate"
                    type="date"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End date</label>
                  <input
                    value={dprFilter?.EndDate}
                    onChange={handleChange}
                    name="EndDate"
                    type="date"
                    className="form-control shadow-none"
                  />
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Project name</label>
                  <input type="text" className="form-control shadow-none" />
                </div>
                <div className="col-6">
                  <label className="filter-label">Recently Added Project</label>
                  <select
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option>Select</option>
                  </select>
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">DPR Name</label>
                  <input
                    type="text"
                    value={dprFilter?.DPRName}
                    name="DPRName"
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">Recently Added DPR</label>
                  <select
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option>Select</option>
                  </select>
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Site Enginner Name</label>
                  <input type="text" className="form-control shadow-none" />
                </div>
                <div className="col-6">
                  <label className="filter-label">DPR Type</label>
                  <select
                    className="filter-label"
                    value={dprFilter?.DPRType}
                    onChange={handleChange}
                    name="DPRType"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option>Select</option>
                  </select>
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Project Status</label>
                  <select
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option>Select</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: 20 }}>
              <span className="resorces">My Approval</span>
            </div>
            <div style={{ marginRight: 20 }}>
              <select
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option>ASC</option>
                <option>DES</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginLeft: 20 }}>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Role"
              value="option1"
            />
            <label for="Role" style={{ fontSize: 14 }}>
              PO Number
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Type"
              value="option1"
            />
            <label for="Type" style={{ fontSize: 14 }}>
              PO Date
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Created"
              value="option1"
            />
            <label for="Created" style={{ fontSize: 14 }}>
              DPR Creation Date
            </label>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-4 pb-4">
          <button className="btn btn-primary" onClick={onFilter}>
            Filter
          </button>
        </div>
      </Modal>

      <Modal open={open} onClose={onCloseModal} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Add Resource {resourceTitle}</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpen(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row" id="dpr-tab">
          <Tabs>
            <TabList>
              <Tab
                onClick={() => {
                  setResourceTitle("Manpower");
                }}
              >
                Manpower
              </Tab>
              <Tab
                onClick={() => {
                  setResourceTitle("Machinery");
                }}
              >
                Machinery
              </Tab>
              <Tab
                onClick={() => {
                  setResourceTitle("Material");
                }}
              >
                Material
              </Tab>
            </TabList>
            <TabPanel>
              <Manpower closeM={closeM} subId={subId} project={projectId} />
            </TabPanel>
            <TabPanel>
              <Machinery closeM={closeM} subId={subId} project={projectId} />
            </TabPanel>
            <TabPanel>
              <Material closeM={closeM} subId={subId} />
            </TabPanel>
          </Tabs>
        </div>

        {/* <div className='row mt-2'>
                        <div class="d-flex justify-content-center">
                            <div style={{ margin: 10 }}>
                                <button className='btn btn-primary'>Submit</button>
                            </div>
                            <div style={{ margin: 10 }}>
                                <button className='btn btn-danger'>Cancel</button>
                            </div>
                        </div>
                    </div> */}
      </Modal>

      <Modal open={openRisk} onClose={onCloseModalRisk} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Risk Register Form</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpenRisk(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <RiskRegisterForm
          subId={subId}
          onSubmit={() => setOpenRisk(false)}
          project={projectId}
        />
      </Modal>

      <Modal open={openIssu} onClose={onCloseModalIssue} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Issue Register Form</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpenIssu(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <IssueRegisterForm
          subId={subId}
          onSubmit={() => setOpenIssu(false)}
          project={projectId}
        />
      </Modal>

      <Modal
        open={openModalRiskList}
        onClose={onCloseModalIssue}
        center
        styles={{
          modal: {
            minWidth: "700px",
            maxWidth: "90%",
          },
        }}
      >
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Risk List</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setSubId("");
                setOpenModalRiskList(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <RiskResgisterList subId={subId} />
      </Modal>
      <Modal
        open={openModalIssueList}
        onClose={onCloseModalIssue}
        center
        styles={{
          modal: {
            minWidth: "700px",
            maxWidth: "90%",
          },
        }}
      >
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Issue List</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setSubId("");
                setOpenModalIssueList(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <IssueResgisterList subId={subId} />
      </Modal>
      <Modal
        open={openResourcesList}
        onClose={() => {}}
        center
        styles={{
          modal: {
            minWidth: "700px",
            maxWidth: "90%",
          },
        }}
      >
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Resource {resourceTitle} List</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpenResoucresList(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row" id="dpr-tab">
          <Tabs>
            <TabList>
              <Tab
                onClick={() => {
                  setResourceTitle("Manpower");
                }}
              >
                Manpower
              </Tab>
              <Tab
                onClick={() => {
                  setResourceTitle("Machinery");
                }}
              >
                Machinery
              </Tab>
              <Tab
                onClick={() => {
                  setResourceTitle("Material");
                }}
              >
                Material
              </Tab>
            </TabList>
            <TabPanel>
              <ManpowerList subId={subId} />
            </TabPanel>
            <TabPanel>
              <MachineryList subId={subId} />
            </TabPanel>
            <TabPanel>
              <Material subId={subId} />
            </TabPanel>
          </Tabs>
        </div>
      </Modal>
      <Modal open={openScopeChart} onClose={() => {}} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Scope Chart</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpenScopeChart(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <ScopeChart
          subId={subId}
          planStart={planStart}
          planFinish={planFinish}
          onSubmit={() => setOpenScopeChart(false)}
          DPRName={dprName}
          balanceScope={balanceScope}
          project={projectId}
        />
      </Modal>
    </React.Fragment>
  );
}
